import React from 'react';

export const tiktokIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <path
        fill="#E6E4FF"
        d="M19.919 0h-4.72v19.072c0 2.273-1.814 4.14-4.073 4.14-2.258 0-4.073-1.867-4.073-4.14 0-2.231 1.774-4.057 3.952-4.139v-4.788c-4.8.081-8.671 4.017-8.671 8.927 0 4.951 3.952 8.928 8.833 8.928 4.88 0 8.832-4.017 8.832-8.928v-9.78a10.93 10.93 0 0 0 6.252 2.11V6.615C22.7 6.493 19.919 3.571 19.919 0"
      ></path>
    </svg>
  );
};
